/**
 * A StateSource with default state and no-op actions, for renderer instances
 * that never leave the welcome modes (the pre-room welcome mount renders
 * nothing from WidgetState and its only gesture — the CTA tap — is forwarded
 * to the host via `onCtaTap`, where the audio-unlock path performs the actual
 * unblock once the room exists).
 */

import type { StateSource, WidgetState } from '../core/logic/widget-state.js';
import { ServiceMode } from '../core/types/service-mode.js';

const INERT_STATE: WidgetState = {
  mode: ServiceMode.Normal,
  captions: [],
  agentState: 'disconnected',
  micStatus: 'ok',
  audioBlocked: false,
  dealerMuted: false,
  suspended: false,
  micJustEnabled: false,
  micAcquired: false,
};

export function createInertStateSource(): StateSource {
  return {
    getState: () => INERT_STATE,
    subscribe: () => () => {},
    actions: {
      startPTT: async () => {},
      endPTT: async () => {},
      cancelPTT: async () => {},
      startAudio: async () => {},
      toggleMute: async () => {},
      sendText: async () => {},
    },
    destroy: () => {},
  };
}
